import React from 'react'
import CustomSelect from '../../../components/CustomSelect/CustomSelect'

export default function AiSettings({
  aiLoading,
  aiSettings,
  setAiSettings,
  aiSaving,
  handleSaveAiSettings,
  confirmDeleteKey,
  setConfirmDeleteKey,
  handleDeleteKey
}) {
  return (
    <div className="settings-section animate-fade-in">
      {aiLoading ? (
        <div className="empty-state">
          <div className="empty-state-icon"><svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg></div>
          <div className="empty-state-title">Загрузка настроек...</div>
        </div>
      ) : (
        <div className="card" style={{ padding: 24 }}>
          <h3 className="settings-section-title" style={{ marginBottom: 8 }}>Настройки ИИ Агента</h3>
          <p className="salary-config-desc" style={{ marginBottom: 24 }}>
            Подключите нейросеть для автоматической работы с вакансиями и кандидатами.
          </p>
          
          <div className="input-group" style={{ marginBottom: 16 }}>
            <CustomSelect
              label="Провайдер ИИ"
              value={aiSettings.provider}
              onChange={val => setAiSettings({...aiSettings, provider: val})}
              options={[
                { value: 'gemini', label: 'Google Gemini (Бесплатно)' },
                { value: 'openrouter', label: 'OpenRouter (Платный/Гибкий)' },
              ]}
            />
          </div>

          <div className="input-group" style={{ marginBottom: 24 }}>
            <label>API Ключ</label>
            <input 
              type="password"
              className="input" 
              placeholder={`Введите ключ ${aiSettings.provider === 'gemini' ? 'Gemini API' : 'OpenRouter'}`}
              value={aiSettings.api_key || ''}
              onChange={e => setAiSettings({...aiSettings, api_key: e.target.value})}
            />
            <div style={{ fontSize: 11, color: 'var(--text-tertiary)', marginTop: 4 }}>
              Ключ сохраняется в защищенном хранилище вашей организации.
            </div>
          </div>

          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            <button 
              className="btn btn-primary" 
              onClick={handleSaveAiSettings}
              disabled={aiSaving || !aiSettings.api_key}
              style={{ flex: 1 }}
            >
              {aiSaving ? 'Сохранение...' : 'Сохранить настройки ИИ'}
            </button>
            {aiSettings.api_key && (
              <button 
                className="btn btn-ghost" 
                style={{ 
                  color: confirmDeleteKey ? 'white' : 'var(--danger)', 
                  borderColor: 'var(--danger)',
                  background: confirmDeleteKey ? 'var(--danger)' : 'transparent',
                  transition: 'all 0.2s ease',
                }}
                disabled={aiSaving}
                onClick={handleDeleteKey}
              >
                {confirmDeleteKey ? (
                  <>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                      <line x1="12" y1="9" x2="12" y2="13"/>
                      <line x1="12" y1="17" x2="12.01" y2="17"/>
                    </svg> Точно удалить?
                  </>
                ) : (
                  <>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="3 6 5 6 21 6"/>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                    </svg> Удалить ключ
                  </>
                )}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
